module.exports = __webpack_public_path__ + "img/select-arrow.0bb8fb0e.svg";